module.exports = __webpack_public_path__ + "static/on_est_pret-00ddbd89f7b027c1ba70fe2c5d37e05f.png";